import { Injectable, ComponentRef } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ProgressSpinnerComponent } from '../common/progress-spinner/progress-spinner.component';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private overlayRef: OverlayRef | null = null;
  private loadingCounter = 0;
  private spinner: ComponentRef<ProgressSpinnerComponent> | undefined;

  constructor(private overlay: Overlay) {}

  public openSpinner() {
    this.loadingCounter++;
    if (!this.overlayRef) {
      const portal = new ComponentPortal(ProgressSpinnerComponent);

      this.overlayRef = this.overlay.create({
        width: '100%',
        height: '100%',
        hasBackdrop: true,
        panelClass: 'progress-spinner',
        backdropClass: 'progress-spinner-backdrop',
      });
      this.spinner = this.overlayRef.attach(portal);
    }
  }

  public closeSpinner() {
    this.loadingCounter--;
    if (this.loadingCounter <= 0 && this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef.dispose();
      this.overlayRef = null;
      this.loadingCounter = 0;
    }
  }
}